export const ERROR_PLACEHOLDERS = {
  PASSWORD_CONFIRM_FIELD_INVALID: 'Passwords do not match',
  INVALID_EMAIL: 'Email should be in name@domain.com format',
}

export const REQUEST_URLS = {
  VALIDATE_PASSWORD: '/validate_password',
}
